import { c as createGlobalConfig, G as GLOBAL_CONFIG } from "../global-config.js";
import { d as defineGlobalProperty } from "../../vue-plugin/utils/global-properties.js";
import { d as defineVuesticPlugin } from "../../vue-plugin/utils/define-vuestic-plugin.js";
const GlobalConfigPlugin = defineVuesticPlugin((config = {}) => ({
  install(app) {
    const globalConfig = createGlobalConfig(config);
    if (config == null ? void 0 : config.componentsAll) {
      console.warn("Global config -> `componentsAll` was moved to Global config -> components.all. Please replace this to make it work. More info here: https://github.com/epicmaxco/vuestic-ui/issues/1967");
    }
    app.provide(GLOBAL_CONFIG, globalConfig);
    defineGlobalProperty(app, "$vaConfig", globalConfig);
  }
}));
export {
  GlobalConfigPlugin as G
};
//# sourceMappingURL=index.js.map
